import { m } from '@/paraglide/messages.js';

/*
 * Held up while the browser is on its way somewhere else — handing an emailed
 * token to the backend, or carrying someone who already has a session on to
 * where they were headed.
 *
 * It exists so neither of those moments shows the wrong screen: without it the
 * login form renders for as long as the navigation takes, and a person who is
 * signed in is asked to sign in.
 */
export function SigningIn() {
  return (
    <main className='flex h-dvh items-center justify-center'>
      <p className='text-md text-ink-muted'>{m.verify_signing_in()}</p>
    </main>
  );
}
